import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { UTILITIES_STATUSES } from 'src/constants/utilities';
import AllocationCounter from './AllocationCounter';
import AllocationProgressBar from './AllocationProgressBar';
import AllocationProgressTable from './AllocationProgressTable';
import useStyles from './styles';
export default function AllocationProgress(_ref) {
  var _allocation$utilities, _allocation$utilities2, _allocation$utilities3;
  let _ref$allocation = _ref.allocation,
    allocation = _ref$allocation === void 0 ? {} : _ref$allocation,
    allocationCycleId = _ref.allocationCycleId,
    statementDate = _ref.statementDate;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  let availables = Object.keys(UTILITIES_STATUSES).filter(s => s !== 'TableReadyStatementSent');
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationInfo,
    "data-tut": "reactour__allocation-progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, allocation.propertyAddress), /*#__PURE__*/React.createElement(AllocationProgressBar, {
    totalSteps: (_allocation$utilities = allocation.utilities) === null || _allocation$utilities === void 0 ? void 0 : _allocation$utilities.length,
    completedSteps: allocation.completedSteps
  })), /*#__PURE__*/React.createElement(Button, {
    disabled: !((_allocation$utilities2 = allocation.utilities) !== null && _allocation$utilities2 !== void 0 && _allocation$utilities2.length),
    variant: "contained",
    size: "small",
    component: RouterLink,
    className: classes.openAllocationButton,
    to: "/allocation_tables?allocationCycleId=".concat(allocationCycleId, "&propertyId=").concat(allocation.propertyId),
    'custom-attribute': '116-allocation-progress'
  }, t('allocations.open_allocation_tables'))), (_allocation$utilities3 = allocation.utilities) !== null && _allocation$utilities3 !== void 0 && _allocation$utilities3.length ? /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    id: "allocation-header",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('allocations.view_allocation_summary'))), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcons,
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, availables.map(status => {
    var _allocation$status;
    return /*#__PURE__*/React.createElement(AllocationCounter, {
      billStatus: status,
      key: status,
      statementDate: statementDate,
      status: (_allocation$status = allocation.status) === null || _allocation$status === void 0 ? void 0 : _allocation$status[status]
    });
  })))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(AllocationProgressTable, {
    noTotal: true,
    allocation: allocation
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.noUtilitiesHint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.this_property_does_not_have_any_utility'))));
}
AllocationProgress.propTypes = {
  allocation: PropTypes.shape({
    showOptimizationBlock: PropTypes.bool,
    enrollment: PropTypes.string,
    billValue: PropTypes.string,
    cad: PropTypes.string,
    goodwillDeduction: PropTypes.string,
    ratioBilled: PropTypes.string,
    submetered: PropTypes.string,
    total: PropTypes.string,
    propertyAddress: PropTypes.string,
    status: PropTypes.shape({
      PendingCompletion: PropTypes.array
    }),
    serviceEndDateOnly: PropTypes.string,
    serviceStartDateOnly: PropTypes.string,
    isCurrent: PropTypes.bool
  })
};